var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-radio-group',{attrs:{"value":true,"row":"","dense":""}},[_c('v-radio',{attrs:{"label":"Active Rates","value":true}})],1),_c('v-divider',{staticClass:"my-5"}),_c('session-rates-report')],1)}
var staticRenderFns = []

export { render, staticRenderFns }